import React from 'react';
import { Volume1 } from 'lucide-react';
import ReactMarkdown from 'react-markdown';
import styles from '../../styles/Training.module.css';
import { TypingIndicator } from '../TypingIndicator/TypingIndicator';

const ConversationDisplay = ({
    conversationHistory,
    isTyping,
    error,
    speakMessage,
    isBotSpeaking,
    isPresentationCoach = false
}) => {
    return (
        <div className={styles.conversationArea}>
            {[...conversationHistory].map((entry, index) => (
                <div
                    key={index}
                    className={`${styles.messageContainer} ${entry.role === 'user' ? styles.userMessage : styles.botMessage}`}
                >
                    <div className={styles.messageHeader}>
                        <span className={styles.speaker}>
                            {entry.role === 'user' ? 'You' : 'Coach'}
                        </span>
                        <div className={styles.messageControls}>
                            {!isPresentationCoach && (
                                entry.role === 'bot' && (
                                    <button
                                        className={styles.speakButton}
                                        onClick={() => speakMessage(entry.content)}
                                        disabled={isBotSpeaking}
                                        aria-label="Speak message"
                                    >
                                        <Volume1 size={14} />
                                    </button>
                                )
                            )}
                            <span className={styles.timestamp}>
                                {new Date(entry.timestamp).toLocaleTimeString()}
                            </span>
                        </div>
                    </div>
                    <div className={styles.messageContent}>
                        {entry.role === 'bot' ? (
                            <ReactMarkdown
                                components={{
                                    a: ({ node, ...props }) => (
                                        // eslint-disable-next-line
                                        <a
                                            {...props}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        />
                                    )
                                }}
                            >
                                {entry.content}
                            </ReactMarkdown>
                        ) : (
                            entry.content
                        )}
                    </div>
                </div>
            ))}
            {isTyping && (
                <div className={`${styles.messageContainer} ${styles.botMessage}`}>
                    <div className={styles.messageHeader}>
                        <span className={styles.speaker}>Coach</span>
                        <span className={styles.timestamp}>
                            {new Date().toLocaleTimeString()}
                        </span>
                    </div>
                    <TypingIndicator />
                </div>
            )}
            {error && (
                <div className={styles.errorMessage}>
                    {error}
                </div>
            )}
        </div>
    );
};

export default ConversationDisplay;